module.exports = __webpack_public_path__ + "img/bijiu-logo.912c3ee7.png";